import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Eyebrow } from './Eyebrow';
interface ClientLogo {
  name: string;
  src: string;
}
const CLIENT_LOGOS: ClientLogo[] = [{
  name: 'TXD',
  src: 'https://cdn.magicpatterns.com/uploads/uYrxFvFEASDw2fg9v9tQjL/TXD-Logo-1.webp'
}, {
  name: 'Sunrise Door Trim',
  src: 'https://cdn.magicpatterns.com/uploads/uZFRa76qR359VyyuRQowLX/Sunrise-door-logo.png'
}, {
  name: 'Redline Pool Tile Restoration',
  src: 'https://cdn.magicpatterns.com/uploads/32nBsB7qz3MTUdrdMNrMkv/hanse-new-logo_redline_pool_tile-200.png'
}, {
  name: 'Goat Cooling and Heating',
  src: 'https://cdn.magicpatterns.com/uploads/27XWGvaVZh4tczFTxpYZUh/goat-cooling-heating-logo.png'
}, {
  name: 'Logistics Now LLC',
  src: 'https://cdn.magicpatterns.com/uploads/nTPdc2dEsf94Hnk4MbMvH7/Logisitcs-Now_LLC_Full_Logo.webp'
}, {
  name: 'Deep Clean',
  src: 'https://cdn.magicpatterns.com/uploads/h7Kb2cjozdG4DLwdLza2sH/Deep-Clean-Favicon.png'
}, {
  name: 'The Patio Cover Company',
  src: 'https://cdn.magicpatterns.com/uploads/bdbwRhKn2tL7wudgqmuetb/a0d9155a-0fbd-4680-849e-286b44dcee72.png'
}, {
  name: 'Sparkle Tech Screen Service',
  src: 'https://cdn.magicpatterns.com/uploads/3h9oUq7LV7cVvao8K2n4Cc/sparkle-tech-screen-service-logo.png'
}, {
  name: 'Drop Zone Cleanup Co.',
  src: 'https://cdn.magicpatterns.com/uploads/m5gRVZfZw9giSSAPNCQjgP/logo.webp'
}, {
  name: 'Allstar Home Solutions',
  src: 'https://cdn.magicpatterns.com/uploads/kU1PhYjz4151dMM3kXotN8/cropped-AllStar-White-Background.png'
}, {
  name: 'All Star',
  src: 'https://cdn.magicpatterns.com/uploads/44UHLTv9tQNZALxVDmUdX9/headerlogo.webp'
}, {
  name: 'Blue Cactus Power Washing',
  src: 'https://cdn.magicpatterns.com/uploads/rD9S2nSMXRWjfvs4psH55T/BlueCactus_Power_Washing_Logo_White.svg'
}, {
  name: 'Summer Breeze Junk Removal',
  src: 'https://cdn.magicpatterns.com/uploads/ttguZ5EcQrTsS4ra4Jrw6n/summer-breeze-logo.png'
}];
export function LogoCarousel() {
  const reducedMotion = useReducedMotion();
  const firstRow = CLIENT_LOGOS.slice(0, 7);
  const secondRow = CLIENT_LOGOS.slice(7);
  return <section className="w-full overflow-hidden bg-[#111415] py-20 text-white lg:py-28" style={{
    backgroundImage: "radial-gradient(ellipse 62% 120% at 50% 48%, rgba(21, 47, 74, 0.9) 0%, rgba(15, 28, 41, 0.72) 46%, rgba(17, 20, 21, 0.2) 100%), url('https://cdn.magicpatterns.com/uploads/scC5pVG3EUePxKUfSG2TRr/Screenshot_2026-07-23_at_10.49.48_AM.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-98" data-mp="re9png9fehfr">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-99" data-mp="8hryazyhojk1">
        <motion.div initial={reducedMotion ? false : {
        opacity: 0,
        y: 16
      }} whileInView={reducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4
      }} className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-100" data-mp="3qug374vdqf1n">
          <div data-id="element-101" data-mp="3lwoc2d2k6wyi">
            <Eyebrow data-id="element-102" data-mp="328s5kedznomi">// The companies we grow</Eyebrow>
            <h2 className="mt-5 max-w-3xl font-display text-5xl uppercase leading-[0.95] sm:text-6xl" data-id="element-103" data-mp="329a7nrnc0x2c">
              Built with businesses<br data-id="element-104" data-mp="2y99gd6f4wrdv" />that show up.
            </h2>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-white/55 sm:pb-1" data-id="element-105" data-mp="3c7r0yv9qtnrk">
            From local service companies to teams built to scale, every logo represents work in progress.
          </p>
        </motion.div>
      </div>

      <div className="relative mt-14 space-y-4 before:pointer-events-none before:absolute before:inset-y-0 before:left-0 before:z-10 before:w-12 before:bg-gradient-to-r before:from-[#111415] before:to-transparent after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:z-10 after:w-12 after:bg-gradient-to-l after:from-[#111415] after:to-transparent sm:before:w-24 sm:after:w-24" data-id="element-106" data-mp="3l5jm4g25bpmv">
        <LogoTrack logos={firstRow} duration={34} direction="left" reducedMotion={reducedMotion} data-id="element-107" data-mp="8nv1koyi1moc" />
        <LogoTrack logos={secondRow} duration={27} direction="right" reducedMotion={reducedMotion} data-id="element-108" data-mp="3pbe2k49c2tv" />
      </div>
    </section>;
}
interface LogoTrackProps {
  logos: ClientLogo[];
  duration: number;
  direction: 'left' | 'right';
  reducedMotion: boolean | null;
}
function LogoTrack({
  logos,
  duration,
  direction,
  reducedMotion
}: LogoTrackProps) {
  const trackLogos = [...logos, ...logos];
  const initialX = direction === 'left' ? '0%' : '-50%';
  const animateX = direction === 'left' ? '-50%' : '0%';
  return <div className="flex overflow-hidden" aria-label="Businesses we work with" data-id="element-109" data-mp="1ja3ux568qbwj">
      <motion.div className="flex min-w-max gap-4 pr-4 sm:gap-5 sm:pr-5" initial={{
      x: initialX
    }} animate={reducedMotion ? undefined : {
      x: animateX
    }} transition={reducedMotion ? undefined : {
      ease: 'linear',
      duration,
      repeat: Infinity
    }} data-id="element-110" data-mp="1jbx6myvpnmbe">
        {trackLogos.map((logo, index) => <div key={`${logo.name}-${index}`} className="flex h-20 w-36 shrink-0 items-center justify-center px-3 py-2 sm:h-24 sm:w-44" aria-hidden={index >= logos.length} data-id="element-111" data-mp="34n6shfiql5hq" data-mpi={index}>
            <img src={logo.src} alt={index < logos.length ? logo.name : ''} loading="lazy" className="max-h-full max-w-full object-contain" data-id="element-112" data-mp="o0qnrl7897oe" />
          </div>)}
      </motion.div>
    </div>;
}